var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "colorCircle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 6.094,
    cy: 6.094,
    r: 6.094,
    transform: "translate(43.677)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 6.094,
    cy: 6.094,
    r: 6.094,
    transform: "translate(65.008 6.094)",
    fill: "#fff",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 6.094,
    cy: 6.094,
    r: 6.094,
    transform: "translate(79.228 21.331)",
    fill: "#fa9a00",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 6.602,
    cy: 6.602,
    r: 6.602,
    transform: "translate(86.338 42.661)",
    fill: "#fecfb0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 6.602,
    cy: 6.602,
    r: 6.602,
    transform: "translate(81.259 66.023)",
    fill: "#ffe953"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 6.094,
    cy: 6.094,
    r: 6.094,
    transform: "translate(65.008 82.275)",
    fill: "#fff07f"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 6.094,
    cy: 6.094,
    r: 6.094,
    transform: "translate(43.677 89.385)",
    fill: "#23e295"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 6.094,
    cy: 6.094,
    r: 6.094,
    transform: "translate(22.346 83.291)",
    fill: "#90f0ca"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 6.094,
    cy: 6.094,
    r: 6.094,
    transform: "translate(4.063 63.992)",
    fill: "#00baef"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 6.602,
    cy: 6.602,
    r: 6.602,
    transform: "translate(0 42.661)",
    fill: "#beedfb"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 6.602,
    cy: 6.602,
    r: 6.602,
    transform: "translate(5.079 22.346)",
    fill: "#8338ec"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 6.094,
    cy: 6.094,
    r: 6.094,
    transform: "translate(22.346 6.094)",
    fill: "#e0cdfa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorCircle);
export default __webpack_public_path__ + "static/media/colorCircle.768c77c7435a57fd123b3f5044f353d8.svg";
export { ForwardRef as ReactComponent };